import { makeAutoObservable } from "mobx"

interface User {
  id?: number
  roles: string[]
  email?: string
  username?: string
  iat?: number
  exp?: number
}

export class UserStore {
  constructor() {
    makeAutoObservable(this)
    this._token = localStorage.getItem("token")
    if (this._token) {
      const userData = this._token.split(".")[1]
      if (userData) {
        this._user = JSON.parse(atob(userData).toString())
      }
    }
  }

  _token: null | string = ""
  _user: User = { roles: [] }

  setToken = (token: string) => {
    this._token = token
    this._setUser()
    localStorage.setItem("token", this._token)
  }

  resetToken = () => {
    this._token = null
    this._user = { roles: [] }
    localStorage.removeItem("token")
  }

  get getToken() {
    return this._token
  }

  get getLang() {
    return localStorage.getItem("i18nextLng")
  }

  get getUser() {
    return this._user
  }

  get isClient() {
    return this._user.roles.includes("ROLE_CLIENT")
  }

  get isManager() {
    return this._user.roles.includes("ROLE_MANAGER_ORD") || this._user.roles.includes("ROLE_MANAGER_REQ")
  }

  get isManagerOrd() {
    return this._user.roles.includes("ROLE_MANAGER_ORD")
  }

  get isManagerReq() {
    return this._user.roles.includes("ROLE_MANAGER_REQ")
  }

  get isManagerStmtRead() {
    return this._user.roles.includes("ROLE_MANAGER_STMT_R") || this._user.roles.includes("ROLE_MANAGER_STMT_W")
  }

  get isManagerStmtWrite() {
    return this._user.roles.includes("ROLE_MANAGER_STMT_W")
  }

  get isAdmin() {
    return this._user.roles.includes("ROLE_ADMIN")
  }

  get isManagement() {
    return (
      this._user.roles.includes("ROLE_MANAGER_ORD") ||
      this._user.roles.includes("ROLE_MANAGER_REQ") ||
      this._user.roles.includes("ROLE_ADMIN")
    )
  }

  _setUser = () => {
    if (this._token) {
      const userData = this._token.split(".")[1]
      if (userData) {
        this._user = JSON.parse(atob(userData).toString())
      }
    }
  }
}

export const userStore = new UserStore()

/*
autorun(() => {
    console.log(userStore._token)
})*/
